import { drProfileClient } from '../../client';

export interface DoctorCentersResponse {
  id: string;
  name: string;
  display_number: string[];
  tell: string[];
  address: string;
  type_id: number;
  status: number;
  server_id: number;
  /** Clinic booking id — required by getFreeTurn / book */
  user_center_id?: string;
  active_booking?: boolean;
  description?: string;
  has_bookable_services: boolean;
  city: {
    id: number;
    name: string;
    slug: string;
    province: {
      id: number;
      name: string;
      slug: string;
    };
  };
  location: {
    lat: number;
    lon: number;
  };
}

export type GetDoctorCentersOptions = {
  /**
   * When true (default), keep only centers with has_bookable_services.
   * Profile SSR passes false so address/phone still show for offices that have
   * schedules in panel but can_booking/has_bookable_services=false.
   */
  onlyBookable?: boolean;
};

export const getDoctorCenters = async (
  slug: string,
  university?: string,
  options?: GetDoctorCentersOptions,
): Promise<DoctorCentersResponse[]> => {
  const onlyBookable = options?.onlyBookable !== false;
  const encodedSlug = encodeURIComponent(slug);
  const url = `/api/doctors/${encodedSlug}/centers`;
  const params: Record<string, string> = {
    check_bookable_services: 'true',
  };
  if (university) {
    params.university = university;
  }
  try {
    const { data } = await drProfileClient.get<DoctorCentersResponse[]>(url, {
      timeout: 5000,
      params,
    });

    if (!onlyBookable) {
      return Array.isArray(data) ? data : [];
    }

    return (Array.isArray(data) ? data : []).filter(center => center.has_bookable_services === true);
  } catch (error) {
    console.error('Error fetching doctor centers:', error);
    return [];
  }
};
